import { tx } from "../lib/tx";
/**
 * Dismissable "What is a BadUSB attack?" info slide — reachable via a small
 * info button layered over the BadUSB consequence dramatization (both the
 * "this actually happened" and "here's what you avoided" framings). Unlike
 * BadUsbExplain.tsx (remote-work-max's cafe-charger juice-jacking variant,
 * which advances the story on close), this one is purely explanatory: it
 * pauses nothing, doesn't advance any beat, and just closes back to whatever
 * was already on screen. Reuses the .bue-* typography classes for a
 * consistent voice but its own wrapper so its z-index sits ABOVE the
 * consequence beat (47) it's meant to float over.
 */
export function BadUsbInfoModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="busb-info-wrap" role="dialog" aria-label={tx("What is a BadUSB attack?")}>
      <div className="busb-info-card">
        <button type="button" className="busb-info-close" onClick={onClose} aria-label={tx("Close")}>
          {"\u2715"}
        </button>
        <div className="bue-kicker">{tx("SECURITY BASICS")}</div>
        <h2>{tx("What is a BadUSB attack?")}</h2>
        <p className="bue-lede">
          {tx("The drive on the desk never needed anyone to open a file or double-click anything. The instant it's plugged in, it can already be attacking the PC.")}
        </p>
        <div className="bue-block">
          <h3>{tx("It pretends to be a keyboard")}</h3>
          <p>
            {tx("USB ports trust device types automatically. A BadUSB drive tells the PC it's a keyboard, so the operating system lets it \"type\" instantly — no permission prompt, no double-click, no warning.")}
          </p>
        </div>
        <div className="bue-block">
          <h3>{tx("It types faster than any human")}</h3>
          <p>
            {tx("In under a second it can open a hidden terminal and run commands that download and install malware — all before anyone would even notice the drive was plugged in.")}
          </p>
        </div>
        <div className="bue-block">
          <h3>{tx("Why it's so hard to catch")}</h3>
          <p>
            {tx("There's no file to scan and no link to click, so antivirus and \"don't click suspicious links\" advice don't help here. The only real defence is never plugging in removable media you can't verify.")}
          </p>
        </div>
        <ul className="bue-facts">
          <li>{tx("No double-click needed — the moment it's plugged in, it can already be typing.")}</li>
          <li>{tx("Antivirus can't catch it early — it isn't a file, it's a fake keyboard.")}</li>
          <li>{tx("It works on any PC or laptop with a free USB port, not just this one.")}</li>
        </ul>
        <button type="button" className="btn busb-info-got-it" onClick={onClose}>
          {tx("Got it — close")}
        </button>
      </div>
    </div>
  );
}
